var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.5L11.5 19.5C9.56704 21.433 6.43304 21.433 4.50004 19.5C2.56704 17.567 2.56704 14.433 4.50004 12.5L6.50004 10.5C8.43304 8.56701 11.567 8.56701 13.5 10.5C13.8064 10.8064 14.0642 11.1429 14.2734 11.5M10.5 6.50001L12.5 4.50001C14.433 2.56701 17.567 2.56701 19.5 4.50001C21.433 6.43301 21.433 9.56702 19.5 11.5L17.5 13.5C15.567 15.433 12.433 15.433 10.5 13.5C10.1937 13.1937 9.93589 12.8571 9.72664 12.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/share-link.cd0da66b.svg";
export { ForwardRef as ReactComponent };